import { ArrowRight, MessageCircle } from "lucide-react";
import { LINKS, REGISTRATION } from "../data/content";
import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";

export const Registration = () => (
    <section
        id="daftar"
        data-testid="pendaftaran-section"
        aria-labelledby="pendaftaran-title"
        className="bg-white py-24 sm:py-32 scroll-mt-20"
    >
        <div className="max-w-[1565px] mx-auto">
            <SectionHeader
                eyebrow={REGISTRATION.eyebrow}
                title={REGISTRATION.title}
                testid="pendaftaran-title"
            />
            <div className="px-6 sm:px-8 grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
                {REGISTRATION.tracks.map((track, i) => {
                    const featured = track.key === "beasiswa";
                    return (
                        <Reveal key={track.key} delay={i * 0.12}>
                            <article
                                data-testid={`pendaftaran-card-${track.key}`}
                                className={`h-full flex flex-col rounded-3xl p-8 sm:p-9 ${
                                    featured
                                        ? "bg-bh-deep text-white border-2 border-bh-gold shadow-[0_22px_54px_rgba(6,76,61,0.28)]"
                                        : "bg-bh-offwhite border border-bh-green/12"
                                }`}
                            >
                                {track.badge && (
                                    <span
                                        data-testid="beasiswa-badge"
                                        className="self-start rounded-full bg-bh-gold px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-bh-ink mb-5"
                                    >
                                        {track.badge}
                                    </span>
                                )}
                                <h3
                                    className={`font-serif font-bold text-2xl sm:text-3xl tracking-tight mb-3 ${
                                        featured ? "text-white" : "text-bh-deep"
                                    }`}
                                >
                                    {track.title}
                                </h3>
                                <p
                                    className={`text-sm leading-relaxed mb-8 ${
                                        featured ? "text-white/75" : "text-bh-gray"
                                    }`}
                                >
                                    {track.description}
                                </p>
                                <div className="mt-auto space-y-3">
                                    <a
                                        href={LINKS.googleForm}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid={`pendaftaran-form-${track.key}`}
                                        className={`inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-3.5 text-xs font-bold uppercase tracking-[0.12em] transition-colors duration-200 ${
                                            featured
                                                ? "bg-bh-gold text-bh-ink hover:bg-bh-softgold"
                                                : "bg-bh-green text-white hover:bg-bh-dark"
                                        }`}
                                    >
                                        {REGISTRATION.formCta}
                                        <ArrowRight className="w-4 h-4" aria-hidden="true" />
                                    </a>
                                    <a
                                        href={LINKS.whatsapp}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid={`pendaftaran-wa-${track.key}`}
                                        className={`inline-flex w-full items-center justify-center gap-2 rounded-full border-2 px-6 py-3 text-xs font-bold uppercase tracking-[0.12em] transition-colors duration-200 ${
                                            featured
                                                ? "border-white/30 text-white hover:border-bh-gold hover:text-bh-softgold"
                                                : "border-bh-green/25 text-bh-dark hover:border-bh-gold"
                                        }`}
                                    >
                                        <MessageCircle className="w-4 h-4" aria-hidden="true" />
                                        {REGISTRATION.waCta}
                                    </a>
                                </div>
                            </article>
                        </Reveal>
                    );
                })}
            </div>
            <Reveal className="text-center mt-12 px-6">
                <p className="text-sm text-bh-gray">
                    Informasi pendaftaran lebih lanjut:{" "}
                    <a
                        href={LINKS.whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="pendaftaran-wa-number"
                        className="mt-1 block font-bold text-bh-green hover:text-bh-dark sm:mt-0 sm:inline"
                    >
                        {LINKS.whatsappDisplay}
                    </a>
                </p>
            </Reveal>
        </div>
    </section>
);
